import { render, staticRenderFns } from "./IframeSettingsModal.vue?vue&type=template&id=2b5f5449"
import script from "./IframeSettingsModal.vue?vue&type=script&lang=js"
export * from "./IframeSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./IframeSettingsModal.vue?vue&type=style&index=0&id=2b5f5449&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports